import { render, staticRenderFns } from "./ServicesLayout.vue?vue&type=template&id=8199bb50&scoped=true&"
import script from "./ServicesLayout.vue?vue&type=script&lang=js&"
export * from "./ServicesLayout.vue?vue&type=script&lang=js&"
import style0 from "./ServicesLayout.vue?vue&type=style&index=0&id=8199bb50&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8199bb50",
  null
  
)

export default component.exports